import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { testimonials } from '../data/offer';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="w-full border-y border-line bg-cream" aria-labelledby="testimonials-heading" data-id="element-271" data-mp="3fycr5ou809bu">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-272" data-mp="3b0aw05jisjk0">
        <SectionLabel data-id="element-273" data-mp="3700qetzn3v5o">Trusted by dog owners like you</SectionLabel>

        <div className="mt-5 flex flex-wrap items-end justify-between gap-3 sm:mt-6 sm:gap-4" data-id="element-274" data-mp="32061gvzfdfn9">
          <h2 id="testimonials-heading" className="font-display text-[1.75rem] font-semibold leading-tight text-ink sm:text-[2.75rem]" data-id="element-275" data-mp="2x0tbi2d9bsgg">
            What owners are saying
          </h2>
          <p className="flex items-center gap-2 text-sm text-muted" data-id="element-276" data-mp="v9oppmy09m41">
            <StarIcon className="h-4 w-4 fill-terracotta text-terracotta" aria-hidden="true" data-id="element-277" data-mp="qac2v274wf1g" />
            <span className="font-bold text-ink" data-id="element-278" data-mp="h5oox8u9426d">4.9/5</span>
            <span data-id="element-279" data-mp="m51dpz4onjbl">· from owners who finished the 30 days</span>
          </p>
        </div>

        <div className="mt-9 grid gap-px bg-line sm:mt-12 lg:grid-cols-2" data-id="element-280" data-mp="m2omevd1bwlv">
          <figure className="flex flex-col justify-between bg-cream px-5 py-7 sm:px-9 sm:py-11" data-id="element-281" data-mp="79bqjxnrh05a">
            <blockquote className="font-display text-xl leading-snug text-ink sm:text-[1.9rem]" data-id="element-282" data-mp="c7dfgz7vbtoo">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4" data-id="element-283" data-mp="14w2aqhm8t4si">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-terracotta/25 bg-terracotta-soft text-sm font-bold text-terracotta-dark" aria-hidden="true" data-id="element-284" data-mp="14xde4gbs0aj3">
                {featured.initials}
              </span>
              <span data-id="element-285" data-mp="1ith6s5704atg">
                <span className="block text-sm font-bold text-ink" data-id="element-286" data-mp="1nmk14fjlroap">
                  {featured.name}
                </span>
                <span className="mt-0.5 block text-xs text-muted" data-id="element-287" data-mp="1xgxv8z0chnh5">
                  {featured.role}
                </span>
              </span>
            </figcaption>
          </figure>

          <div className="grid gap-px bg-line sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2" data-id="element-288" data-mp="1ogjac0ramae6">
            {rest.map(item => <figure key={item.name} className="flex flex-col justify-between bg-cream px-5 py-6 sm:px-6 sm:py-7" data-id="element-289" data-mp="1jhpu40kmg5ab">
                <blockquote className="text-sm leading-relaxed text-ink/80 sm:text-[15px]" data-id="element-290" data-mp="19s6bmw0tmdfz">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3" data-id="element-291" data-mp="14r8xqvmug5ka">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line bg-white text-[11px] font-bold text-terracotta" aria-hidden="true" data-id="element-292" data-mp="10t1he1wal69m">
                    {item.initials}
                  </span>
                  <span data-id="element-293" data-mp="32ge0gxlc6vuh">
                    <span className="block text-xs font-bold text-ink" data-id="element-294" data-mp="32j9z6o50dojz">
                      {item.name}
                    </span>
                    <span className="mt-0.5 block text-[11px] text-muted" data-id="element-295" data-mp="3cek4plum8e2i">
                      {item.role}
                    </span>
                  </span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}